import { getBranding } from '../config/branding';

const branding = getBranding();

export const formatCurrency = (amount: number): string => {
  const { symbol, locale } = branding.currency;
  return `${symbol}${Number(amount || 0).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatCurrencyNoDecimals = (amount: number): string => {
  const { symbol, locale } = branding.currency;
  return `${symbol}${Number(amount || 0).toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
};
